"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sarnico": {
    "8404982e": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "skipSearch": false
    }],
    "campomatto-pirone": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef0f2b2f": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "898d7091": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "skipSearch": false
    }],
    "castione": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7033c6d9": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "skipSearch": false
    }],
    "fosio": [{
      "hkey": "3a0cff7d",
      "slug": "sarnico",
      "name": "Sarnico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;